const VN_BASE_HOST = "web-bookrclass.go.vn";

export const isVietnamHost = () => {
  if (typeof window === "undefined" || !window.location?.hostname) {
    return false;
  }

  return window.location.hostname.toLowerCase() === VN_BASE_HOST;
};
